import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import RouteMap from './route/index'
import Utils from './utils/utils'
import { Toast } from 'antd-mobile'
import { req_wxLogin, req_getTeacherInfo, req_findRecordById } from './api/api'
import cookie from 'react-cookies'
import IP from './config/config'
import 'antd/dist/antd.css';
import { Modal } from 'antd-mobile'
import getQueryString from './utils/sha1'

const alert = Modal.alert;

class App extends Component {

  state = {
    isShow: false
  }

  componentDidMount = async () => {
    Toast.loading("正在登陆中...", 0)
    if (cookie.save('type') == 'app') {
      this.setState({
        isShow: true
      })
      return
    }
    // 判断是微信登录，还是云上黄淮登录
    const type = getQueryString('type')
    if (type === 'app') {
      const token = getQueryString('token')
      if (token) {
        cookie.save('type', 'app')
        cookie.save('token', token)
        this.getLogin()
      } else {
        Toast.fail('非法进入！')
      }
    } else {
      // 加个延时，防止页面加载的时候，加密未加载完成，提示查不到
      setTimeout(() => {
        this.handleLogin()
      }, 1);
    }

    // const token = getQueryString('token')
    // if (token) {
    //   cookie.save('type', 'app')
    //   cookie.save('token', token)
    //   this.getLogin()
    // } else {
    //   alert('提示', '未获取到认证信息！', [
    //     {
    //       text: '取消', onPress: () => {}
    //     },
    //     {
    //       text: '确定', onPress: () => {}
    //     },
    //   ])
    // }
  }

  handleLogin = async () => {
    // 如果过来携带了teacher
    const code = Utils.GetQueryString('code');
    const record_id = Utils.GetQueryString('record_id');
    if (code) {
      const result = await req_wxLogin({ code })
      if (result.code !== 20000) {
        if (result.code === 40029 || result.code === 20001) {
          return window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${IP.appId}&redirect_uri=${IP.wxredirect}&response_type=code&scope=snsapi_userinfo&state${record_id}=&connect_redirect=1#wechat_redirect`
        }
        return Toast.fail(result.message)
      }
      Toast.hide()
      // 基础
      cookie.save('token', result.data.sessionId)
      cookie.save('type', '')


      const state = Utils.GetQueryString('state');
      if (state != 'null') {
        const res = await req_findRecordById({ recordId: state })
        if (res.code === 20000) {
          if (res.data.type_id != null) {
            Toast.offline("该链接已失效,请联系相关人员！", 0)
            return false
          }
          cookie.save('code', res.data.teacher_code) // code是教师code
          cookie.save('record_id', res.data.record_id) // 记录ID
        }
      } else {
        cookie.remove('record_id')
        cookie.save('code', 'null') // code是教师code
      }
      this.setState({
        isShow: true
      })
    } else {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${IP.appId}&redirect_uri=${IP.wxredirect}&response_type=code&scope=snsapi_userinfo&state=${record_id}&connect_redirect=1#wechat_redirect`;
    }
  }

  getLogin = async () => {
    const res = await req_getTeacherInfo()
    if (res.code === 20000) {
      Toast.hide()
      cookie.save('teacher_code', res.data.teacher_code)
      this.setState({
        isShow: true
      })
    } else {
      alert('提示', res.message, [
        {
          text: '取消', onPress: () => {}
        },
        {
          text: '确定', onPress: () => {}
        },
      ])
    }
  }

  render() {
    const { isShow } = this.state
    return (
      <div>
        {isShow && <BrowserRouter>
          <RouteMap />
        </BrowserRouter>}
      </div>
    )
  }
}

export default App;